// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__R9cPq","amount":"Amount_amount__VqdRb","tip":"Amount_tip__1WfDJ","tipHeader":"Amount_tipHeader__tO3UV","tipsWrap":"Amount_tipsWrap__3qRce"};